import {
  isDocumentPanelState,
  isImagePanelState,
  isLogPanelState,
  isMapPanelState,
  isPlotPanelState,
  isRawMessagePanelState,
  isThreeDPanelState,
  usePanelState,
} from "@/shared/state/visualization";

import { PanelSettingsSidebarProps } from "../sidebarContext/sidebarView";
import { useSelectedPanelId } from "../WorkspaceCtx";

import { DocumentPanelSettings } from "./DocumentPanelSettings";
import { EmptyPanelSettings } from "./EmptyPanelSettings";
import { ImagePanelSettings } from "./ImagePanelSettings";
import { LogPanelSettings } from "./LogPanelSettings";
import { MapPanelSettings } from "./MapPanelSettings";
import { NoSelectedPanelMessage } from "./NoSelectedPanelMessage";
import { PlotPanelSettings } from "./PlotPanelSettings";
import { RawMessagePanelSettings } from "./RawMessagePanelSettings";
import { ThreeDPanelSettings } from "./ThreeDPanelSettings";

export function PanelSettings(props: PanelSettingsSidebarProps) {
  const selectedPanelId = useSelectedPanelId();
  const panelState = usePanelState(selectedPanelId);

  if (!panelState) {
    return <NoSelectedPanelMessage />;
  }

  if (isDocumentPanelState(panelState)) {
    return <DocumentPanelSettings state={panelState} {...props} />;
  }

  if (isImagePanelState(panelState)) {
    return <ImagePanelSettings state={panelState} {...props} />;
  }

  if (isLogPanelState(panelState)) {
    return <LogPanelSettings state={panelState} {...props} />;
  }

  if (isMapPanelState(panelState)) {
    return <MapPanelSettings state={panelState} {...props} />;
  }

  if (isPlotPanelState(panelState)) {
    return <PlotPanelSettings state={panelState} {...props} />;
  }

  if (isRawMessagePanelState(panelState)) {
    return <RawMessagePanelSettings state={panelState} {...props} />;
  }

  if (isThreeDPanelState(panelState)) {
    return (
      <ThreeDPanelSettings
        key={selectedPanelId}
        state={panelState}
        {...props}
      />
    );
  }

  return <EmptyPanelSettings />;
}
